<div *ngIf="dialog.show" class="overlayForPopups">
  <div cdkDrag>
    <uitk-dialog [(showModal)]="dialog.show" uitkId="isbnProductSelectDialog" [closeBtn]="false">
      <uitk-dialog-header>
        <div cdkDragHandle>
          Multiple Products Found
        </div>
      </uitk-dialog-header>
      <uitk-dialog-content>
        <p>Multiple products share this ISBN. Please select one:</p>
        <uitk-radio-group uitkId="isbnRadioGroup"
                          name="isbnRadioGroup"
                          [itemList]="itemList"
                          [(ngModel)]="selectedProduct">
        </uitk-radio-group>
      </uitk-dialog-content>
      <uitk-dialog-actions>
        <div class="text-center">
          <button class="uitk-c-button uitk-c-button--default uitk-u-margin--xxs"
                  [disabled]="!selectedProduct"
                  (click)="confirm()">Ok</button>
          <button class="uitk-c-button uitk-c-button--ghost uitk-u-margin--xxs"
                  (click)="cancel()">Cancel</button>
        </div>
      </uitk-dialog-actions>
    </uitk-dialog>
  </div>
</div>